export default __webpack_public_path__ + "static/media/logo-dark.aadd9281.png";